export type ReadinessScoreTone =
  | "needs-attention"
  | "getting-close"
  | "on-track"
  | "strong"
  | "ready";

export interface ReadinessScoreAppearance {
  label: string;
  markerClassName: string;
  strokeClassName: string;
  textClassName: string;
  tone: ReadinessScoreTone;
}

export function getReadinessScoreAppearance(
  score: number,
): ReadinessScoreAppearance {
  if (score < 45) {
    return {
      label: "Needs attention",
      markerClassName: "bg-destructive",
      strokeClassName: "text-destructive",
      textClassName: "text-destructive",
      tone: "needs-attention",
    };
  }

  if (score < 65) {
    return {
      label: "Getting close",
      markerClassName: "bg-warning",
      strokeClassName: "text-warning-foreground",
      textClassName: "text-warning-foreground",
      tone: "getting-close",
    };
  }

  if (score < 80) {
    return {
      label: "On track",
      markerClassName: "bg-primary/70",
      strokeClassName: "text-primary/70",
      textClassName: "text-primary",
      tone: "on-track",
    };
  }

  if (score < 90) {
    return {
      label: "Strong",
      markerClassName: "bg-primary",
      strokeClassName: "text-primary",
      textClassName: "text-primary",
      tone: "strong",
    };
  }

  return {
    label: "Ready",
    markerClassName: "bg-primary-dark",
    strokeClassName: "text-primary-dark",
    textClassName: "text-primary-dark",
    tone: "ready",
  };
}
